export default "__VITE_ASSET__DxfGh9Vx__"